import i18n from 'src/i18n';
import Formatter from 'src/class/Formatter';

const configTable = () => {
  const tableColumns = [
    {
      prop: 'code',
      label: i18n.t('common_words.code'),
      minWidth: 100,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'homologated_code',
      label: i18n.t('common_words.code_homologated'),
      align: 'center',
      show: false,
    },
    {
      prop: 'name',
      label: i18n.t('common_words.name'),
      minWidth: 150,
      sortable: true,
    },
    {
      prop: 'description',
      label: i18n.t('common_words.description'),
      minWidth: 300,
    },
    {
      prop: 'amount',
      label: i18n.t('common_words.value'),
      minWidth: 120,
      sortable: true,
      formatter: (row, column) => {
        return `$${Formatter.formatNumber(Number(row[column.property]))}`;
      },
    },
    {
      prop: 'payment_frequency',
      label: i18n.t('labor.payment_frequency'),
      minWidth: 180,
      sortable: true,
    },
    {
      prop: 'payment_limit',
      label: `${i18n.t('labor.payment_limit')} (${i18n.t(
        'common_words.days'
      )})`,
      minWidth: 200,
      sortable: true,
      formatter: (row, column) => {
        if (Number(row[column.property]) === 0) return 'NA';

        return `a ${Formatter.formatNumber(
          Number(row[column.property])
        )} ${i18n.t('common_words.days')}`;
      },
    },
  ];

  return { tableColumns };
};

export default configTable;
